import { LINKS_FILTER_OPTIONS } from '../../link-form/filters/constants';
import { NULL_COHORTS_ID } from './get-filter-options';

// Generates map of locations to their "child" cohort values
const getLocationToCohortMap = () => {
  const result = {};

  Object.values(LINKS_FILTER_OPTIONS).forEach((location) => {
    const { value: locationValue, subFilters } = location;

    if (subFilters) {
      result[locationValue] = Object.values(subFilters).map(
        (cohort) => cohort.value
      );
    }
  });

  return result;
};

const LOCATION_TO_COHORTS = getLocationToCohortMap();

export const byCohort = (cohorts) => (link) => {
  if (!cohorts?.length) return true;

  return cohorts.every((selectedCohort) => {
    if (selectedCohort === NULL_COHORTS_ID) {
      return !link.filters?.length;
    }

    const hasSelectedCohort = link.filters.includes(selectedCohort);

    // e.g. if MALAYSIA_GENERAL is selected, then links with MALAYSIA_DOMESTIC, MALAYSIA_INTERNATIONAL, etc would be shown, bc they are "children" of MALAYSIA_GENERAL
    const childCohorts = LOCATION_TO_COHORTS[selectedCohort];
    const hasChildCohort =
      childCohorts &&
      link.filters.some((linkCohort) => childCohorts.includes(linkCohort));

    return hasSelectedCohort || hasChildCohort;
  });
};
